import { css } from 'aphrodite/no-important';
import { RedButton } from 'components/RedButton/RedButton';
import { VideoData } from 'models';
import React, { FC } from 'react';
import { PlayIcon } from 'util/icons';
import { style } from './style';

interface Props {
  video: VideoData;
  onAbstractAndBioClick: () => void;
  onVideoClick: () => void;
}

export const TrackSession: FC<Props> = ({ video, onAbstractAndBioClick, onVideoClick }) => {
  const styles = style();
  const isVideoPlayable = !!video.video_url;

  const handleVideoClick = () => {
    if (onVideoClick) {
      onVideoClick();
    }
  };

  const handleAbstractAndBioClick = (event: any) => {
    if (event) event.preventDefault();
    if (onAbstractAndBioClick) {
      onAbstractAndBioClick();
    }
  };

  return (
    <article className={css(styles.container)}>
      <div className={css(styles.thumbnail)}>
        <picture>
          <source media='(min-width: 768px)' srcSet={video.thumbnail_url} />
          <img src={video.mobile_thumbnail_url} alt={video.video_title} />
        </picture>
      </div>
      {isVideoPlayable && (
        <div className={css(styles.playButton)}>
          <button onClick={handleVideoClick}>
            <PlayIcon /> Play Video
          </button>
        </div>
      )}
      <RedButton className={css(styles.abstractAndBioButton)} onClick={handleAbstractAndBioClick}>
        Abstract / Speaker bio
      </RedButton>

      {video.video_category_title && (
        <span className={css(styles.title, styles.category)}>{video.video_category_title}</span>
      )}
      <span className={css(styles.title)} dangerouslySetInnerHTML={{ __html: video.video_title }}></span>
      <span
        className={css(styles.companies)}
        dangerouslySetInnerHTML={{ __html: video.speaker_titles.join(' / ') }}></span>
      <span
        className={css(styles.speakers)}
        dangerouslySetInnerHTML={{ __html: video.speaker_names.join(', ') }}></span>
    </article>
  );
};
